import { LatLng } from 'leaflet'

import {
  VIDEO_TIME_UPDATE,
  VIDEO_SEEK_TO,
  SET_TRACK_CURRENT_IDX,
  SET_TRACK_POINTS,
  SET_TRACK_DISTANCES
} from './mutation-types'

export default {
  [VIDEO_TIME_UPDATE]: (store, { payload }, state) => {
    if (state.track.points) {
      const millis = Math.round(payload * 1000)
      let idx = Math.round(millis / state.track.interval)
      const lastIdx = state.track.points.length - 1
      idx = idx < lastIdx ? idx : lastIdx
      if (idx !== state.track.current_idx) {
        store.commit(SET_TRACK_CURRENT_IDX, { idx, skipSync: true })
      }
    }
  },

  [SET_TRACK_CURRENT_IDX]: (store, { payload: { idx, skipSync } }, state) => {
    const point = state.track.points[idx]
    if (point && !skipSync) {
      store.commit(VIDEO_SEEK_TO, point.dur / 1000)
    }
  },

  [SET_TRACK_POINTS]: (store, mutation, state) => {
    const distances = state.track.points.reduce((m, v) => {
      let previous = m.pop()
      if (previous) {
        let meters = new LatLng(v.lat, v.lng).distanceTo(previous)
        m.push(m[m.length - 1] + Math.round(meters))
      } else {
        m.push(0)
      }
      m.push([v.lat, v.lng])
      return m
    }, [])
    distances.pop()
    store.commit(SET_TRACK_DISTANCES, distances)
  }
}



// WEBPACK FOOTER //
// ./src/store/effects.js